const translations = {
  "en": {
    "DeepSearch": "DeepSearch"
  },
  "zh-tw": {
    "DeepSearch": "深度搜尋"
  }
};

export default translations;
